import { useState } from "react";
import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { PageHeader } from "@/layouts/AdminLayout";
import { UserDialog } from "@/components/technicians/UserDialog";
import { TechnicianProfile } from "@/components/technicians/TechnicianProfile";
import { useAuth } from "@/context/AuthContext";
import { ROLE_LABEL } from "@/lib/constants";
import { TECH_TYPE, useList } from "@/lib/technicians";

const Flag = ({ on, yes, no }) => <span className={on ? "text-emerald-400" : "text-muted-foreground"}>{on ? yes : no}</span>;

export default function Users() {
  const { can } = useAuth();
  const [users, reload] = useList("/users");
  const [zones] = useList("/zones");
  const [specialties] = useList("/specialties");
  const [dlg, setDlg] = useState(null);
  const [profileId, setProfileId] = useState(null);
  const specName = (c) => specialties.find((s) => s.code === c)?.name || c;
  const open = (u) => (u.role === "technician" ? setProfileId(u.id) : can("users.write") && setDlg({ user: u }));

  return (
    <div>
      <PageHeader eyebrow={`${users.length} usuarios`} title="Usuarios y técnicos">
        {can("users.write") && <Button onClick={() => setDlg({})} data-testid="new-user-button"><Plus className="mr-1 h-4 w-4" />Nuevo usuario</Button>}
      </PageHeader>
      <div className="overflow-x-auto rounded-xl border border-border bg-card/30">
        <Table data-testid="users-table">
          <TableHeader>
            <TableRow className="hover:bg-transparent">
              {["Nombre", "Correo", "Rol", "Tipo", "Especialidades", "Estado"].map((h) => <TableHead key={h} className="font-mono text-[11px] uppercase tracking-wider">{h}</TableHead>)}
            </TableRow>
          </TableHeader>
          <TableBody>
            {users.map((u) => {
              const p = u.technician_profile;
              return (
                <TableRow key={u.id} className="cursor-pointer" onClick={() => open(u)} data-testid={`user-row-${u.email || u.id}`}>
                  <TableCell className="font-medium">{u.name}{p?.company && <div className="text-xs text-muted-foreground">{p.company}</div>}</TableCell>
                  <TableCell className="text-sm">{u.email || <span className="text-muted-foreground">—</span>}</TableCell>
                  <TableCell className="text-sm">{ROLE_LABEL[u.role]}</TableCell>
                  <TableCell className="text-sm" data-testid={`user-type-${u.id}`}>{p ? TECH_TYPE[p.type] : "—"}</TableCell>
                  <TableCell className="max-w-[260px] text-xs text-muted-foreground">{(p?.specialty_codes || []).map(specName).join(", ")}</TableCell>
                  <TableCell><Flag on={u.active} yes="Activo" no="Inactivo" /></TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </div>
      <UserDialog open={!!dlg} onOpenChange={(o) => !o && setDlg(null)} user={dlg?.user} zones={zones} specialties={specialties} onSaved={() => { reload(); setProfileId(null); }} />
      <TechnicianProfile techId={profileId} onOpenChange={(o) => !o && setProfileId(null)} zones={zones} onEdit={(t) => { setProfileId(null); setDlg({ user: t }); }} />
    </div>
  );
}
